import { Link } from "react-router-dom";
export default function ArticleCard({ slug, img, title, category, excerpt }) {
    return (
        <Link to={`/article/${slug}`} className="block group">
            <div className="
        bg-white
        border border-gray-200
        rounded-xl
        overflow-hidden
        shadow-sm
        hover:shadow-lg
        transition
        h-[340px]
        flex flex-col
      ">

                {/* IMAGE */}
                <div className="h-[170px] overflow-hidden">
                    <img
                        src={img}
                        alt={title}
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
                    />
                </div>

                {/* CONTENT */}
                <div className="p-5 flex flex-col flex-grow">

                    {/* CATEGORY */}
                    <span className="
            inline-block
            bg-black
            text-white
            text-xs
            font-semibold
            px-3 py-1
            rounded-full
            w-fit
            mb-3
          ">
                        {category}
                    </span>

                    {/* TITLE */}
                    <h2 className="
            text-lg
            font-semibold
            text-gray-900
            leading-snug
            mb-2
            line-clamp-2
          ">
                        {title}
                    </h2>

                    {/* EXCERPT */}
                    <p className="
            text-sm
            text-gray-600
            leading-relaxed
            line-clamp-3
            mt-auto
          ">
                        {excerpt}
                    </p>

                </div>
            </div>
        </Link>
    );
}
